/**
 * Shared site chrome sizing so the header, footer, and page content
 * share the same max-width and horizontal padding at every breakpoint.
 */
export const SITE_SHELL = "mx-auto w-full max-w-7xl px-4 sm:px-6";

/** Horizontal padding only — pair with a narrower max-width (article, 1–2 posts). */
export const SITE_PAD_X = "px-4 sm:px-6";
